import React, { Component } from 'react'
import ErrorBoundary from '@argos/error-boundary'
import { Drawer } from '@sainsburys-tech/fable'

import styles from './AskTrevor.scss'

class AskTrevor extends Component {
  constructor(props) {
    super(props)
    this.iframeRef = React.createRef()
    this.state = {
      isOpen: false,
    }

    this.iframeReady = false
    this.pendingMessage = null

    this.toggleTrevor = this.toggleTrevor.bind(this)
    this.handleIframeReady = this.handleIframeReady.bind(this)
    this.handleIframeMessage = this.handleIframeMessage.bind(this)
  }

  componentDidMount() {
    window.addEventListener('message', this.toggleTrevor)
    window.addEventListener('message', this.handleIframeReady)
    window.addEventListener('message', this.handleIframeMessage)

    // Pre-open the drawer if the URL contains the query param 'trevor=open'
    if (window.location.search.includes('trevor=open')) {
      this.setState({ isOpen: true })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.toggleTrevor)
    window.removeEventListener('message', this.handleIframeReady)
    window.removeEventListener('message', this.handleIframeMessage)
  }

  toggleTrevor(event) {
    if (event.data === 'close-trevor-drawer') {
      this.setState({ isOpen: false })
    }

    if (event.data === 'open-trevor-drawer') {
      this.setState({ isOpen: true })
    }
  }

  handleIframeReady(event) {
    if (event.data !== 'trevor-iframe-ready') {
      return
    }

    const contentWindow = this.iframeRef.current?.contentWindow
    if (!contentWindow) {
      return
    }

    const message = this.pendingMessage || 'trevor-show-empty-screen'
    contentWindow.postMessage(message, window.location.origin)
    this.pendingMessage = null
    this.iframeReady = true
  }

  handleIframeMessage(event) {
    if (event.data?.type !== 'trevor-action') {
      return
    }

    const contentWindow = this.iframeRef.current?.contentWindow

    if (this.iframeReady && contentWindow) {
      contentWindow.postMessage(event.data.payload, window.location.origin)
    } else {
      this.pendingMessage = event.data.payload
    }

    this.setState({ isOpen: true })
  }

  render() {
    const { isOpen } = this.state

    return (
      <ErrorBoundary>
        <Drawer
          id='trevor-drawer'
          isOpen={isOpen}
          onClose={() => this.setState({ isOpen: false })}
          position='right'
          padding={{
            none: 'none',
          }}
          size={{
            none: 'full',
            sm: 'lg',
            md: 'md',
            lg: 'md',
          }}
          className={styles.drawer}>
          <iframe
            ref={this.iframeRef}
            src='/trevor/chat'
            id='trevor-iframe-embed'
            title='Ask Trevor application'
            loading='lazy'
            style={{ width: '100%', height: '100%' }}
            sandbox='allow-same-origin allow-scripts allow-forms allow-popups'
          />
        </Drawer>
      </ErrorBoundary>
    )
  }
}

export default AskTrevor
